import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Form,
  Table,
  Button,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import Loading from "../shared/Loading.js";
import {
  DateFormat,
  Select,
  deleteRequest,
  postJsonData,
  putJsonData,
} from "../Helper.js";
import { useContext } from "react";

import moment from "moment";
import { AppContext } from "../context/AppContext.js";
// import { confirm } from "react-confirm-box";

function Master({
  masterlabel,
  id,
  fields,
  variant,
  submitUrl,
  updateUrl = submitUrl,
  getAllUrl,
  deleteUrl,
  primaryKey,
  newEntryForm = true,
}) {
  const [setLoaderActive, toast, myConfirm] = useContext(AppContext);
  const [masterRows, setMasterRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const adviceRef = useRef({});
  const [isValidated, setValidated] = useState(false);
  const [editFormValidated, setEditFormValidated] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandState, setExpandState] = useState({});
  const [editSelected, setEditSelected] = useState({});

  async function fetchMasterRows() {
    try {
      setLoaderActive(true);
      const response = await fetch(getAllUrl).then((response) =>
        response.json()
      );
      if (response.success) {
        setMasterRows(response.response);
      } else {
        response.response.messages.map((res) => {
          toast.error(res);
        });
      }
    } catch (ex) {
      console.log(ex);
      toast.error("Something went wrong");
    } finally {
      setLoaderActive(false);
    }
  }
  const handleAdviceAdd = async (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setValidated(true);
    if (error) return false;
    let itemSelected = {};
    fields.forEach((field) => {
      const ele = adviceRef.current[field.ref];
      if (field.controlType === "check") {
        itemSelected[field.ref] = ele.checked;
      } else if (field.controlType === "select") {
        itemSelected[field.ref] = ele.input.value;
        if (field.tableValue) {
          itemSelected[field.tableValue] =
            ele.input.options[ele.input.selectedIndex].innerHTML;
        }
      } else {
        itemSelected[field.ref] = ele.value;
      }
    });

    itemSelected = {
      ...itemSelected,
      [primaryKey]: 0,
    };

    try {
      setLoaderActive(true);
      const response = await postJsonData(submitUrl, itemSelected);
      if (response.success) {
        form.reset();
        setValidated(false);
        refreshCustomSelects();
        fetchMasterRows();
      } else {
        response.response.messages.map((res) => {
          toast.error(res);
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoaderActive(false);
    }
  };

  const handleAdviceUpdate = async (e, key) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setEditFormValidated(true);
    if (error) return false;
    const oldAdvice = {
      ...masterRows.find((s) => s[primaryKey] === key),
    };
    let itemSelected = editSelected[key][0];
    //itemSelected.files = oldAdvice.files;
    fields.forEach((field) => {
      const ele = adviceRef.current[field.ref + "_" + key];
      if (field.controlType === "check") {
        itemSelected[field.ref] = ele.checked;
      } else if (field.controlType === "select") {
        itemSelected[field.ref] = ele.input.value;
        if (field.tableValue) {
          itemSelected[field.tableValue] =
            ele.input.options[ele.input.selectedIndex].innerHTML;
        }
      } else {
        itemSelected[field.ref] = ele.value;
      }
    });

    itemSelected = {
      ...oldAdvice,
      ...itemSelected,
    };

    try {
      // const url = updateUrl !== "" ? updateUrl : submitUrl;
      const response = await putJsonData(updateUrl, itemSelected);
      if (response.success) {
        form.reset();
        setValidated(false);
        refreshCustomSelects();
        fetchMasterRows();
        handleExpandRow(response.response[0][primaryKey]);
      } else {
        response.response.messages.map((res) => {
          toast.error(res);
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoaderActive(false);
    }
  };

  const handleExpandRow = (key) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(key);
    if (isRowExpanded === false)
      setEditSelected({
        ...editSelected,
        [key]: [masterRows.find((p) => p[primaryKey] === key)],
      });
    let obj = expandState;
    isRowExpanded ? (obj[key] = false) : (obj[key] = true);
    setExpandState(obj);

    // If the row is expanded, we are here to hide it. Hence remove
    // it from the state variable. Otherwise add to it.
    let newExpandedRows = [];
    if (isRowExpanded)
      newExpandedRows = currentExpandedRows.filter((row) => row !== key);
    else newExpandedRows = currentExpandedRows.concat(key);

    setExpandedRows(newExpandedRows);
  };
  const handleAdviceEdit = (key) => {
    let obj = expandState;
    obj[key] = "edit";
    setExpandState({ ...obj });
  };

  const handleDeleteClick = async (key) => {
    const result = await myConfirm("Are you sure?");
    if (result) {
      const response = await deleteRequest(deleteUrl, key);
      if (response.success) {
        refreshCustomSelects();
        fetchMasterRows();
        toast.success("Deleted!!!");
      } else {
        toast.error("Failed!!!");
      }
      return;
    }
    //toast.info("Action aborted!!!");
  };

  useEffect(() => {
    fetchMasterRows();
  }, [getAllUrl, setMasterRows]);

  const refreshCustomSelects = () => {
    fields.forEach((field) => {
      if (field.controlType === "select") {
        adviceRef.current[field.ref].refresh();
      }
    });
  };
  return (
    <Container>
      <Card className="mb-3 rounded-0 inner-card" border={variant} id={id}>
        <Card.Header
          className={"rounded-0 bg-" + variant + " text-white print-black"}
          as="h5"
        >
          {masterlabel}
        </Card.Header>
        <Card.Body>
          {isLoading === true ? (
            <Loading />
          ) : isLoading === "error" ? (
            <Loading failed={true} />
          ) : (
            <>
              {newEntryForm && (
                <Form
                  noValidate
                  validated={isValidated}
                  onSubmit={(e) => handleAdviceAdd(e)}
                  className="d-print-none"
                >
                  <fieldset>
                    <Row sm={3}>
                      {fields.map((field, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Col key={index}>
                              <Form.Group className="mb-3">
                                <Form.Label>{field.label}</Form.Label>
                                {field.controlType === undefined && (
                                  <Form.Control
                                    {...field.props}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  />
                                )}
                                {field.controlType === "select" && (
                                  <Select
                                    inputProps={field.props}
                                    dataUrl={field.dataUrl}
                                    defaultLabel={field.defaultLabel}
                                    options={field.options}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  />
                                )}
                                {field.controlType === "check" && (
                                  <Form.Check
                                    {...field.props}
                                    ref={(el) =>
                                      (adviceRef.current[field.ref] = el)
                                    }
                                  />
                                )}
                              </Form.Group>
                            </Col>
                          </React.Fragment>
                        );
                      })}

                      <Col lg={12} className="text-end mb-3">
                        <Button type="submit" variant={variant}>
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                </Form>
              )}
              <div className="vh-75 overflow-auto scroll-new">
                <Table bordered responsive>
                  <colgroup>
                    {/* <col style={{ width: "110px" }} /> */}

                    <col
                      span={
                        fields.filter(
                          (f) => f.hidden === undefined || f.hidden === false
                        ).length
                      }
                    />
                  </colgroup>
                  <thead>
                    <tr>
                      {fields.map((field, index) => {
                        return (
                          <React.Fragment key={index}>
                            {!field.hidden && (
                              <th key={index}>{field.label}</th>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {masterRows.map((row) => {
                      return (
                        <React.Fragment key={row[primaryKey]}>
                          <tr
                            className={
                              expandState[row[primaryKey]] === true
                                ? "table-warning"
                                : expandState[row[primaryKey]] === "edit"
                                ? "table-danger"
                                : ""
                            }
                            role="button"
                            onClick={() => handleExpandRow(row[primaryKey])}
                          >
                            {fields.map((field, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {!field.hidden && (
                                    <td>
                                      {field.controlType === "check" ? (
                                        <Form.Check
                                          checked={row[field.ref]}
                                          disabled
                                        />
                                      ) : row[field.tableValue] ? (
                                        row[field.tableValue]
                                      ) : (
                                        row[field.ref]
                                      )}
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tr>
                          {expandedRows.includes(row[primaryKey]) && (
                            <tr className="d-print-none">
                              <td colSpan={fields.length}>
                                <Form
                                  noValidate
                                  validated={editFormValidated}
                                  onSubmit={(e) =>
                                    handleAdviceUpdate(e, row[primaryKey])
                                  }
                                >
                                  <fieldset>
                                    <Row sm={3}>
                                      {fields.map((field, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            <Col key={index}>
                                              <Form.Group className="mb-3">
                                                <Form.Label>
                                                  {field.label}
                                                </Form.Label>

                                                {field.controlType ===
                                                  undefined && (
                                                  <Form.Control
                                                    {...field.props}
                                                    ref={(el) =>
                                                      (adviceRef.current[
                                                        field.ref +
                                                          "_" +
                                                          row[primaryKey]
                                                      ] = el)
                                                    }
                                                    defaultValue={
                                                      row[field.ref]
                                                    }
                                                    readOnly={
                                                      expandState[
                                                        row[primaryKey]
                                                      ] === true
                                                    }
                                                  />
                                                )}
                                                {field.controlType ===
                                                  "select" && (
                                                  <Select
                                                    dataUrl={field.dataUrl}
                                                    defaultLabel={
                                                      field.defaultLabel
                                                    }
                                                    options={field.options}
                                                    inputProps={{
                                                      ...field.props,
                                                      defaultValue:
                                                        row[field.ref],
                                                      disabled:
                                                        expandState[
                                                          row[primaryKey]
                                                        ] === true,
                                                    }}
                                                    ref={(el) =>
                                                      (adviceRef.current[
                                                        field.ref +
                                                          "_" +
                                                          row[primaryKey]
                                                      ] = el)
                                                    }
                                                  />
                                                )}

                                                {field.controlType ===
                                                  "check" && (
                                                  <Form.Check
                                                    {...field.props}
                                                    ref={(el) =>
                                                      (adviceRef.current[
                                                        field.ref +
                                                          "_" +
                                                          row[primaryKey]
                                                      ] = el)
                                                    }
                                                    defaultChecked={
                                                      row[field.ref]
                                                    }
                                                    disabled={
                                                      expandState[
                                                        row[primaryKey]
                                                      ] === true
                                                    }
                                                  />
                                                )}
                                              </Form.Group>
                                            </Col>
                                          </React.Fragment>
                                        );
                                      })}

                                      <Col lg={12} className="text-end mb-3">
                                        {expandState[row[primaryKey]] ===
                                          true && (
                                          <>
                                            <Button
                                              type="button"
                                              variant={variant}
                                              onClick={() =>
                                                handleAdviceEdit(
                                                  row[primaryKey]
                                                )
                                              }
                                            >
                                              Edit
                                            </Button>
                                            <Button
                                              type="button"
                                              variant="danger"
                                              className="ms-2"
                                              onClick={() =>
                                                handleDeleteClick(
                                                  row[primaryKey]
                                                )
                                              }
                                            >
                                              Delete
                                            </Button>
                                          </>
                                        )}
                                        {expandState[row[primaryKey]] ===
                                          "edit" && (
                                          <>
                                            <input
                                              type="hidden"
                                              ref={(el) =>
                                                (adviceRef.current[
                                                  "key_" + row[primaryKey]
                                                ] = el)
                                              }
                                            />
                                            <Button
                                              type="button"
                                              variant="outline-danger"
                                              className="ms-3"
                                              onClick={() =>
                                                handleExpandRow(row[primaryKey])
                                              }
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              type="submit"
                                              className="ms-3"
                                              variant={`outline-${variant}`}
                                            >
                                              Update
                                            </Button>
                                          </>
                                        )}
                                      </Col>
                                    </Row>
                                  </fieldset>
                                </Form>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Master;
